import { GeneralAttributeBase } from './base/general-attribute-base';

export class GeneralAttribute extends GeneralAttributeBase { }